export default __webpack_public_path__ + "static/media/sanjivani-dust-tea.605e1da4.png";